import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import { useSidePanelEdgeTab } from './hooks';

import { useEdges } from '~/api/easy-estimator-api/edges-api/useEdges';
import { UNIT_MEASURE } from '~/core/constants';
import formatUOM from '~/core/helpers/formatUOM';
import { formatPriceUnitOrFree, getProductDescription } from '~/core/utils';
import DesignOptionIn3DModal from '~organisms/DesignOptionIn3DModal';
import EdgesHeader from '~organisms/EdgesHeader';
import EdgesList from '~organisms/EdgesList';

const SidePanelEdgeTab = (): JSX.Element | null => {
  const { t } = useTranslation();

  const {
    modalFor3DCarousel,
    selectManualEdge,
    areThereShapesInTheDrawingArea,
    applySameEdge,
  } = useSidePanelEdgeTab();
  const { isFetchingEdges, sortedEdges: edges } = useEdges();

  return areThereShapesInTheDrawingArea ? (
    <>
      <EdgesHeader applySameEdge={applySameEdge} />
      {isFetchingEdges ? (
        <Spin style={{ fontSize: 24 }} />
      ) : (
        edges.length > 0 && (
          <>
            <EdgesList
              edges={edges}
              onClick3DBtn={modalFor3DCarousel.setOptionIndex}
              selectManualEdge={selectManualEdge}
            />

            <DesignOptionIn3DModal
              options={edges.map((edge) => ({
                data: edge,
                display: {
                  title: getProductDescription(edge),
                  price: formatPriceUnitOrFree(
                    edge.price,
                    formatUOM(edge.unitOfMeasure || UNIT_MEASURE.EDGE),
                    true
                  ),
                  image: edge.imageUrl,
                },
              }))}
              optionIndex={modalFor3DCarousel.optionIndex}
              isOpen={modalFor3DCarousel.isOpen}
              onClose={modalFor3DCarousel.close}
              selectOption={selectManualEdge}
              buttonText={t('DESIGN_TOOLBAR.SELECT', {
                option: t('COMMON.EDGE'),
              })}
            />
          </>
        )
      )}
    </>
  ) : null;
};

export default SidePanelEdgeTab;
